import React from 'react';

import ModalDrawer from './ModalDrawer';
import PersistentDrawer from './PersistentDrawer';

import type { Props as ModalDrawerProps } from './ModalDrawer';
import type { Props as PersistentDrawerProps } from './PersistentDrawer';

export const DrawerPositions = {
  LEFT: 'left',
  RIGHT: 'right'
} as const;

export type DrawerPosition = typeof DrawerPositions[keyof typeof DrawerPositions];

type Props = (
  (ModalDrawerProps & { persist: false })
  | (PersistentDrawerProps & { persist: true })
)

const Drawer = (props: Props) => {
  const {
    persist = false,
  } = props;

  // Persistent Drawer
  // --- always kept in DOM - for SEO concerns
  if (persist === true) {
    return <PersistentDrawer {...props} />;
  }

  // Modal Drawer
  // --- not kept in DOM
  if (persist === false) {
    return <ModalDrawer {...props} />;
  }
};

export default Drawer;
